import { createApp, h } from 'vue';

import {TranslationService, ApiService, DOMUtil} from 'webshop-modules';
import TicketSelection from './TicketSelection.vue';
import { ApiPlugin } from "@/plugins/api.plugin";
import { TranslationPlugin } from "@/plugins/translation.plugin";
import { TicketSelectionApplicationData } from "@/domain/ticket-selection/entities";
import {
    InGroupsOfRequirementsProvider,
    PriceListOrderingProvider,
    PriceListValidityProvider,
    SeatmapPriceCategoryAvailabilityProvider,
    StructureIntegrityProvider
} from "@/domain/ticket-selection/data/providers";
import { createPinia, getActivePinia } from "pinia";
import vSelect from 'vue-select';

// Initial data
const configScript = DOMUtil.getInjectedConfigurationScript(document, 'ticketSelection.js') as HTMLScriptElement;
let data: TicketSelectionApplicationData = JSON.parse(configScript.getAttribute('data-initial') as string) as TicketSelectionApplicationData;
configScript.removeAttribute('data-initial');

// attach default displayModeState TODO: refactor
data.displayState = {
    bestSeat: !data.eventInformation.showSeatmap,
    seatmap: {
        isSeatmapVisible: data.eventInformation.showSeatmap,
        isMenuExpanded: false,
    }
};

data = StructureIntegrityProvider.provideIntegrityForApplication(data);
data = PriceListValidityProvider.provideValidPriceListForApplication(data);
data = SeatmapPriceCategoryAvailabilityProvider.setPriceCategoryAvailabilityForApplication(data);
data = InGroupsOfRequirementsProvider.decorateTicketTypesWithPriceLevelInGroupsOfSetting(data);
data = PriceListOrderingProvider.provideCorrectPriceListOrder(data);

const ticketSelectionInstance = createApp({
    render: () => h(TicketSelection, { data }),

    data() {
        return data;
    }
});

//pinia initialization
const pinia = getActivePinia() ?? createPinia();
ticketSelectionInstance.use(pinia);

// Set module plugins
ticketSelectionInstance.use(new ApiPlugin(ApiService.getInjectedConfiguration(document, 'ticketSelection.js')));
ticketSelectionInstance.use(new TranslationPlugin(TranslationService.getConfiguration(document, 'ticketSelection.js')));

// Set global component
ticketSelectionInstance.component('v-select', vSelect);

// Global filters
ticketSelectionInstance.config.globalProperties.$filters = {
    capitalize(value) {
        if (!value) return '';
        return value.charAt(0).toUpperCase() + value.slice(1);
    },
    lowercase(value) {
        if (!value) return '';
        return value.toLowerCase();
    }
};

ticketSelectionInstance.mount('#ticket-selection');
